import { createContext } from '@lit/context';
import { CollectionMenuState, ProductMenuState } from './menu-state.js';

export const productMenuContext = createContext<ProductMenuState>('productMenuContext');
export const collectionMenuContext = createContext<CollectionMenuState>('collectionMenuContext');
